import { PUB_SUB_EVENTS, setCookie, subscribe } from '../storefront/globals';

class CartRemoveButton extends HTMLElement {
  autoRemoveProductGwpFlag = true;

  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const {
        index: itemIndex = 0,
        gwpVariantId = '',
        isGlobalGwp = false,
      } = this.dataset;

      // Auto Remove Product Level GWP
      if (this.autoRemoveProductGwpFlag && gwpVariantId) {
        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          this.removeRelatedGwp.bind(this),
        );
      }

      // For Global level GWP
      if (isGlobalGwp === 'true') {
        this.handleGlobalGwpRemove();
      }

      const cartItems =
        this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(itemIndex, 0);
    });
  }

  removeRelatedGwp() {
    const { gwpVariantId } = this.dataset;
    const cartItems =
      this.closest('cart-items') || this.closest('cart-drawer-items');

    const gwpLineIndex = cartItems
      .querySelector(`[data-variant-id="${gwpVariantId}"]`)
      ?.closest('cart-remove-button').dataset.index;

    if (!gwpLineIndex) return;

    cartItems.updateQuantity(gwpLineIndex, 0);

    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  handleGlobalGwpRemove() {
    /**
     * Prevent Global GWP to be added again when it is manually removed
     */
    setCookie('giftCookie', 'submitted', 1);
  }
}

customElements.define('cart-remove-button', CartRemoveButton);
